import React,{Component} from 'react';
import {Route, Routes, useLocation} from 'react-router-dom';
import {NavMenuLeft} from './NavMenuLeft';
import {ProgramManagement} from './ProgramManagement';
import {ProgramCreate} from './ProgramCreate';
import {ProgramList} from './ProgramList';
import {ProgramPlus} from './ProgramPlus';
import {ProgramPlusEdit} from './ProgramPlusEdit';
import {ProgramPlusView} from './ProgramPlusView';
import {HighlightMaster} from './HighlightMaster';
import {IconMaster} from './IconMaster';
import {LocationMaster} from './LocationMaster';
import {AirlineMaster} from './AirlineMaster';
import {HomeSlideMaster} from './HomeSlideMaster';
import {MomentMaster} from './MomentMaster';
import {HashtagMaster} from './HashtagMaster';
import {ContactMessages} from './ContactMessages';
import {ContactSettings} from './ContactSettings';
import {AboutSettings} from './AboutSettings';
import {UserMaster} from './UserMaster';
import {ProgramLog} from './ProgramLog';
import {AuditLog} from './AuditLog';
import {CustomerList} from './CustomerList';
import {CustomerEdit} from './CustomerEdit';
import {GroupRequestList} from './GroupRequestList';
import {GroupRequestDetail} from './GroupRequestDetail';
import {ConsoleHome} from './ConsoleHome';
import {HotelManagement} from './HotelManagement';
import { PlacesManagement } from './PlacesManagement';

function AdminOnly({ children }) {
  var role = localStorage.getItem('role') || '';
  if (role !== 'admin') {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <i className="fas fa-lock" style={{ fontSize: 48, color: '#dc3545', marginBottom: 12 }}></i>
        <h5>ไม่มีสิทธิ์เข้าถึง</h5>
        <p style={{ color: '#888' }}>หน้านี้เฉพาะผู้ดูแลระบบ (admin) เท่านั้น</p>
      </div>
    );
  }
  return children;
}

export class Console extends Component {
  render() {
    return (
      <ConsoleLayout>
        <Routes>
          <Route exact path='/' element={<ConsoleHome />} />
          <Route path='/programs' element={<ProgramList />} />
          <Route path='/programmanagement' element={<ProgramManagement />} />
          <Route path='/programcreate' element={<ProgramCreate />} />
          <Route path='/programplus' element={<ProgramPlus />} />
          <Route path='/programplus/create' element={<ProgramPlusEdit />} />
          <Route path='/programplus/edit/:id' element={<ProgramPlusEdit />} />
          <Route path='/programplus/view/:id' element={<ProgramPlusView />} />
          <Route path='/master/highlights' element={<HighlightMaster />} />
          <Route path='/master/icons' element={<IconMaster />} />
          <Route path='/master/location' element={<LocationMaster />} />
          <Route path='/master/airlines' element={<AirlineMaster />} />
          <Route path='/master/homeslide' element={<HomeSlideMaster />} />
          <Route path='/users' element={<AdminOnly><UserMaster /></AdminOnly>} />
          <Route path='/programlog' element={<AdminOnly><ProgramLog /></AdminOnly>} />
          <Route path='/auditlog' element={<AdminOnly><AuditLog /></AdminOnly>} />
          <Route path='/customer' element={<CustomerList />} />
          <Route path='/customer/add' element={<CustomerEdit />} />
          <Route path='/customer/edit/:id' element={<CustomerEdit />} />
          <Route path='/tools/homeslide' element={<HomeSlideMaster />} />
          <Route path='/tools/moment' element={<MomentMaster />} />
          <Route path='/tools/hashtag' element={<HashtagMaster />} />
          <Route path='/contact' element={<ContactMessages />} />
          <Route path='/master/contactinfo' element={<ContactSettings />} />
          <Route path='/master/aboutus' element={<AboutSettings />} />
          <Route path='/grouprequest' element={<GroupRequestList />} />
          <Route path='/grouprequest/:id' element={<GroupRequestDetail />} />
          <Route path='/hotelmanagement' element={<HotelManagement />} />
          <Route path='/Places' element={<PlacesManagement />} />
        </Routes>
      </ConsoleLayout>
    )
  }
}
const SEGMENT_TITLES = {
  'tools': { title: 'Tools', icon: 'fas fa-tools' },
  'programplus': { title: 'Program Plus', icon: 'fas fa-globe-asia' },
  'programs': { title: 'Programs', icon: 'fas fa-list' },
  'programmanagement': { title: 'Program Management', icon: 'fas fa-cog' },
  'programcreate': { title: 'สร้างโปรแกรม', icon: 'fas fa-plus' },
  'create': { title: 'สร้างใหม่', icon: 'fas fa-plus' },
  'edit': { title: 'แก้ไข', icon: 'fas fa-edit' },
  'view': { title: 'ดูรายละเอียด', icon: 'fas fa-eye' },
  'master': { title: 'Master', icon: 'fas fa-layer-group' },
  'highlights': { title: 'ทำไมต้องไปกับเรา?', icon: 'fas fa-star' },
  'icons': { title: 'Icon ของวัน', icon: 'fas fa-icons' },
  'location': { title: 'ทวีป / ประเทศ / จังหวัด', icon: 'fas fa-map-marked-alt' },
  'airlines': { title: 'สายการบิน', icon: 'fas fa-plane' },
  'homeslide': { title: 'Slide หน้า Home', icon: 'fas fa-images' },
  'moment': { title: 'ภาพประทับใจ', icon: 'fas fa-camera' },
  'hashtag': { title: 'Hashtag หน้าบ้าน', icon: 'fas fa-hashtag' },
  'contact': { title: 'ข้อความติดต่อ', icon: 'fas fa-envelope-open-text' },
  'contactinfo': { title: 'ข้อมูลติดต่อ / Social', icon: 'fas fa-address-card' },
  'aboutus': { title: 'เกี่ยวกับเรา', icon: 'fas fa-info-circle' },
  'grouprequest': { title: 'คำขอจัดกรุ๊ป', icon: 'fas fa-users' },
  'hotelmanagement': { title: 'Hotel Management', icon: 'fas fa-hotel' },
  'Places': { title: 'Places', icon: 'fas fa-map-marker-alt' },
  'users': { title: 'จัดการผู้ใช้งาน', icon: 'fas fa-users-cog' },
  'programlog': { title: 'ประวัติการแก้ไขโปรแกรม', icon: 'fas fa-history' },
  'auditlog': { title: 'ประวัติ Login / การใช้งาน', icon: 'fas fa-user-shield' },
  'customer': { title: 'จัดการลูกค้า', icon: 'fas fa-user-friends' },
  'add': { title: 'เพิ่มลูกค้า', icon: 'fas fa-user-plus' }
};

function buildBreadcrumb(path) {
  var parts = path.split('/').filter(x => x && x !== 'console');
  var crumbs = [];
  parts.forEach((seg) => {
    if (/^\d+$/.test(seg)) return;
    var m = SEGMENT_TITLES[seg];
    if (m) crumbs.push({ title: m.title, icon: m.icon });
    else crumbs.push({ title: seg, icon: null });
  });
  return crumbs.length === 0 ? [{ title: 'Dashboard', icon: 'fas fa-tachometer-alt' }] : crumbs;
}

function ConsoleHeader({ collapsed, onToggle }) {
  var location = useLocation();
  var crumbs = buildBreadcrumb(location.pathname);
  var last = crumbs[crumbs.length - 1];
  var displayName = localStorage.getItem('displayName') || 'User';
  var role = localStorage.getItem('role') || '';
  var handleLogout = () => {
    if (!window.confirm('ออกจากระบบใช่หรือไม่?')) return;
    try {
      fetch('api/auditlog', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: localStorage.getItem('username') || '', displayName, eventType: 'LOGOUT', target: '', detail: '' }),
        keepalive: true
      });
    } catch {}
    localStorage.clear();
    window.location.href = '/login';
  };

  // Page-view tracking on route change (console-only)
  React.useEffect(() => {
    var username = localStorage.getItem('username') || '';
    if (!username) return;
    var pageTitle = crumbs.map(c => c.title).join(' / ');
    try {
      fetch('api/auditlog', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, displayName, eventType: 'PAGE_VIEW', target: location.pathname, detail: pageTitle })
      });
    } catch {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return (
    <div style={{ background:'#fff', borderBottom:'1px solid #e5e5e5', padding:'12px 24px', display:'flex', alignItems:'center', justifyContent:'space-between', boxShadow:'0 2px 8px rgba(0,0,0,0.04)', position:'sticky', top:0, zIndex:100 }}>
      <div className="d-flex align-items-center" style={{ gap:16 }}>
        <button type="button" onClick={onToggle} style={{ border:'none', background:'transparent', fontSize:20, color:'#666', cursor:'pointer', padding:'6px 10px' }} title={collapsed ? 'เปิดเมนู' : 'ซ่อนเมนู'}>
          <i className={collapsed ? 'fas fa-bars' : 'fas fa-angle-double-left'}></i>
        </button>
        <img src="/images/ANT_LOGO.png" alt="ANT" style={{ height:36, width:'auto', objectFit:'contain' }} />
        <div style={{ width:1, height:32, background:'#e5e5e5' }}></div>
        <div className="d-flex align-items-center flex-wrap" style={{ gap:6, fontSize:14 }}>
          {crumbs.map((c, i) => (
            <React.Fragment key={i}>
              {i > 0 && <i className="fas fa-chevron-right" style={{ fontSize:10, color:'#bbb' }}></i>}
              <span style={{ fontWeight: i === crumbs.length - 1 ? 700 : 500, color: i === crumbs.length - 1 ? '#333' : '#888' }}>
                {c.icon && <i className={c.icon} style={{ color: i === crumbs.length - 1 ? '#dc3545' : '#aaa', marginRight:6 }}></i>}
                {c.title}
              </span>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div className="d-flex align-items-center" style={{ gap:16 }}>
        <div className="d-none d-md-flex align-items-center" style={{ gap:10, padding:'6px 14px', background:'#f8f9fa', borderRadius:20 }}>
          <div style={{ width:32, height:32, borderRadius:'50%', background:'#dc3545', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:13 }}>
            {(displayName.charAt(0) || 'U').toUpperCase()}
          </div>
          <div style={{ lineHeight:1.2 }}>
            <div style={{ fontSize:13, fontWeight:600, color:'#333' }}>{displayName}</div>
            {role && <div style={{ fontSize:10, color:'#888' }}>{role}</div>}
          </div>
        </div>
        <button className="btn btn-outline-danger btn-sm" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i> ออกจากระบบ
        </button>
      </div>
    </div>
  );
}

export class ConsoleLayout extends Component {
  constructor(props) {
    super(props);
    var saved = false;
    try { saved = localStorage.getItem('consoleSidebarCollapsed') === '1'; } catch {}
    this.state = { collapsed: saved };
  }
  toggleSidebar = () => {
    var next = !this.state.collapsed;
    this.setState({ collapsed: next });
    try { localStorage.setItem('consoleSidebarCollapsed', next ? '1' : '0'); } catch {}
  }

  render() {
    var { collapsed } = this.state;
    return (
      <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <ConsoleHeader collapsed={collapsed} onToggle={this.toggleSidebar} />
        <div className="row m-0" style={{ flex: 1, minHeight: 0 }}>
          {!collapsed && (
            <div className="col-md-3 col-xl-2 db-sidebar nav-site " style={{ height: '100%', overflowY: 'auto', overflowX: 'hidden' }}>
              <NavMenuLeft />
            </div>
          )}
          <main className={(collapsed ? 'col-12' : 'col-md-9 col-xl-10') + ' pymd-3 db-content p-0'} style={{ height: '100%', overflowY: 'auto' }}>
            <div className="container-fulid">
              {this.props.children}
            </div>
          </main>
        </div>
      </div>
    );
  }
}
